export default "__VITE_ASSET__VvhY5VcH__"